/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'height': {
    width: 12,
    height: 30,
    viewBox: '0 0 12 30',
    data: '<path pid="0" d="M8 5.625h4L6 0 0 5.625h4v18.75H0L6 30l6-5.625H8z" _fill="#000" fill-rule="nonzero" opacity=".06"/>'
  }
})
